import { combineReducers } from 'redux';

import advisors from './advisors';
import chat from './chat';
import pubnub from './pubnub';
import advisorOrders from './advisor_orders';
import orderDetails from './order_details';
import auth from './auth';
import user from './user';
import intro from './intro';
import funds from './funds';
import notifyMe from './notifyMe';
import transcript from './transcript';
import settings from './settings';
import passwordForgot from './password_forgot';
import paymentSources from './payment_sources';
import paymentOptions from './payment_options';
import applicationError from './application_error';
import purchaseDetails from './purchase_details';
import affiliatePromoPopup from './affiliate_promo_popup';
import voipChat from './voip_chat';
import homePage from './home_page';
import application from './application';
import creditCardProcessing from './credit_card_processing';
import creditCardValidateProcessing from './credit_card_validate_processing';
import messageToApp from './message_to_app';
import topup from './topup';

export default combineReducers({
  advisors,
  chat,
  pubnub,
  advisorOrders,
  orderDetails,
  auth,
  user,
  intro,
  funds,
  notifyMe,
  transcript,
  settings,
  passwordForgot,
  paymentSources,
  applicationError,
  voipChat,
  paymentOptions,
  purchaseDetails,
  affiliatePromoPopup,
  homePage,
  application,
  creditCardProcessing,
  creditCardValidateProcessing,
  messageToApp,
  topup
});
